<template>
  <div
    class="habit-wrapper"
  >
    <div class="content-wrapper-wrapper" :class="{ shake: disabled }">
      <div>
        <div @click="clickEvent"
          style="padding-left: 10px;"
        >
          <radial-progress-bar
            startColor="#8dc898"
            stopColor="#8dc898"
            innerStrokeColor="#d3d3d375"
            :diameter="40"
            :strokeWidth="5"
            :innerStrokeWidth="4"
            :completed-steps="totalSteps < completedSteps ? totalSteps : completedSteps"
            :total-steps="totalSteps">
            <p v-if="haveAnimation">
              {{ completedSteps }}/{{ totalSteps }}
            </p>
            <radial-progress-bar
              v-if="succesRate"
              startColor="#E0B965"
              stopColor="#E0B965"
              innerStrokeColor="black"
              :diameter="25"
              :strokeWidth="5"
              :animateSpeed="300"
              :innerStrokeWidth="4"
              :completed-steps="succesRate.coundSucces"
              :total-steps="succesRate.count">
              <div style="position: relative;">
                <span style="
                  position: absolute;
                  top: -25px;
                  left: -21px;
                  background: #3A4276;
                  border-radius: 100px;
                  color: white;
                  padding: 2px 5px;
                  font-size: 16px;
                  font-weight: 900;
                "
                  v-if="series">{{ series }}</span>
              </div>
            </radial-progress-bar>
          </radial-progress-bar>
        </div>
      </div>
    <div class="content-wrapper"
      @click="clickEvent">
        <div style="width: 100%;">{{ percent }}% {{ habit.name }}</div>
    </div>
    <slot/>
    </div>
  </div>
</template>
<script>
import RadialProgressBar from 'vue-radial-progress';

export default {
  props: {
    isCheckObject: Object,
    succesRate: Object,
    checkEvent: Function,
    habit: Object,
    index: Number,
    haveAnimation: Boolean,
    series: Number,
    percent: Number,
  },
  data() {
    return {
      isDone: false,
      disabled: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.isDone = true;
    }, 1500);
  },
  components: {
    RadialProgressBar,
  },
  computed: {
    completedSteps() {
      return this.isCheckObject.logsValue;
    },
    totalSteps() {
      return this.isCheckObject.valueForDone || 1;
    },
    time() {
      return this.$moment(this.habit.time, 'HHmm').format('HH:mm');
    },
    checkHabit() {
      return this.isCheckObject.isDone;
    },
  },
  methods: {
    clickEvent() {
      this.disabled = !this.disabled;
      setTimeout(() => {
        this.disabled = !this.disabled;
      }, 100);
      if (this.checkEvent) {
        this.checkEvent(this.habit, this.index);
      }
    },
  },
};
</script>

<style scoped lang="scss">
  .habit-wrapper {
    display: flex;
    align-items: flex-start;
    position: relative;
    justify-content: flex-end;
    margin: 15px 0 15px 0;
    min-height: 75px ;
    padding: 0 10px;
    .content-wrapper {
      font-size: 0.8rem;
      font-weight: 600;
      margin-left: 15px;
      -webkit-user-select: none; /* Safari */
      -moz-user-select: none; /* Firefox */
      -ms-user-select: none; /* IE10+/Edge */
      user-select: none; /* Standard */
      width: 60%;
      word-wrap: break-word
    }
    .content-wrapper-wrapper {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      background: $background-light-color;
      box-shadow:
        0 2.8px 4.2px rgba(0, 0, 0, 0.01),
        0 6.7px 5.3px rgba(0, 0, 0, 0.01),
        0 12.5px 10px rgba(0, 0, 0, 0.01),
        0 22.3px 17.9px rgba(0, 0, 0, 0.01),
        0 41.8px 33.4px rgba(0, 0, 0, 0.01),
        0 100px 80px rgba(0, 0, 0, 0.01);
      width: 100%;
      border-radius: 30px;
      padding: 5px 5px;
    }
  }
  .time-wrapper {
    font-size: 0.9rem;
    font-weight: 600;
    color: #b2b2b2;
    padding-top: 5px;
  }
.shake {
  animation: color 9s infinite linear;
}
@keyframes color {
  0%   { background: #3e537a; }
  100% { background: #3e537a; }
}
</style>
